import {useGlobalStore} from "@/stores/global-store";
import {Request} from "superagent";

export function APIRequest(method, url) {
    const global_store = useGlobalStore()
    const full_url = global_store.api_url + url
    const req = new Request(method, full_url)
    req.withCredentials()
    req.on("error", err => {
        if (err && err.status === 401 && location.pathname !== "/login") {
            global_store.old_path = location.pathname
            location = "/login"
        }
        return err
    })
    return req
}

/*
Retourne un message lisible à partir d'une erreur superagent (erreur HTTP ou réseau)
 */
export function getErrorMessage(err) {
    if (err && err.response) {
        if (err.response.body && err.response.body.error_message)
            return err.response.body.error_message
        return "HTTP " + err.status
    }
    return String(err)
}


